<div class="encolumnat">
    <h1 class="titol">{{ 'REGISTERCOMPONENT.COMPANY_INFO.TITLE' | translate }}</h1>
    <h2 class="texte">{{ 'REGISTERCOMPONENT.COMPANY_INFO.SUBTITLE' | translate }}</h2>
    <shared-tenantinfo-component  (onValidationChange)="canRegister = $event" [(tenantInfo)]="registerData.organization"></shared-tenantinfo-component>
    <div class="button-zone">
        <button mat-flat-button color="primary" class="action seguent sol" [disabled]="!canRegister || pendigResponse"
            (click)="next()">{{'REGISTERCOMPONENT.NEXTBUTTON.LABEL' | translate}}</button>
    </div>
</div>